import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description Inventory Api Service
 */
const InventoryApiService = {

  getFilterTagList: async (apiUrl, data) => {
    try {

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      return await APIService.post(apiUrl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, apiUrl, err)
    }
  },

  getInventory: async (selectedAccount, apiUrl, data, filterData) => {
    try {
      const dataRequest = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }

        if (data['pageSize']) {
          dataRequest['limit'] = data['pageSize']
        }

        if (data['currentPage']) {
          dataRequest['page'] = data['currentPage']
        }

        if (data['isForceRefresh']) {
          dataRequest['isForceRefresh'] = data['isForceRefresh']
        }

        if (filterData['field'] !== 'tags' && filterData['field'] !== '' && filterData['value'] !== '') {
          dataRequest['searchingFilter'] = filterData['field']
          dataRequest['searchingValue'] = [filterData['value']]
        }
        if (filterData['field'] !== '' && filterData['field'] === 'tags' && filterData['tagField'] !== '' && filterData['tagValue']?.length > 0 ) {
          dataRequest['searchingFilter'] = filterData['field']
          dataRequest['searchTagKey'] = filterData['tagField']?.['Key']
          dataRequest['searchingValue'] = filterData['tagValue']
        }
      }

      return await APIService.post(apiUrl, dataRequest)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, apiUrl, err)
    }
  },

  getUntaggedInventory: async (selectedAccount) => {
    try {
      const dataRequest = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }
      }

      return await APIService.post(APIConstants.ENDPOINT_INVENTORY_TAG_UNTAGGED_INSTANCES, dataRequest)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching untagged inventory`, err)
    }
  },

  getInventoryByDate: async (apiUrl, date) => {
    try {
      let url = `${apiUrl}`

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userAccounts'] && parseToJson['userAccounts'][0] && parseToJson['userAccounts'][0]['accountId']) {
          url += `?userAccountId=${parseToJson['userAccounts'][0]['accountId']}`
        }

        if (date) {
          url += `&date=${date}`
        }
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory for date ${date}`, apiUrl, err)
    }
  },

  getScheduledEvents: async (selectedAccount, apiUrl) => {
    try {
      let url = `${apiUrl}`

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching scheduled events`, apiUrl, err)
    }
  },

  deleteScheduledEvents: async (apiUrl, data) => {
    try {
      let url = `${apiUrl}`

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while deleting scheduled instances`, apiUrl, data, err)
    }
  },



  getModifiedEvents: async (selectedAccount, apiurl, data) => {
    let url = `${apiurl}`

    if (selectedAccount) {
      url += `?userAccountId=${selectedAccount}&`
    }

    if (data['fromDate']) {
      url += `fromDate=${data['fromDate']}&`
    }

    if (data['toDate']) {
      url += `toDate=${data['toDate']}`
    }

    try {
      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching modified events`, apiurl, data, err)
    }
  },

  instantAction: async (apiurl, data) => {
    let url = `${apiurl}`

    try {
      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while ${data['status']}ing inventory instance`, apiurl, data, err)
    }
  },

  getActivityInventory: async (apiurl, data) => {
    let url = `${apiurl}`

    try {
      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching activity data`, apiurl, data, err)
    }
  },

  scheduleEvents: async (apiurl, data) => {
    try {
      return await APIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while scheduling event`, apiurl, data, err)
    }
  },

  saveData: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_INVENTORY_SAVE_DATA, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while saving inventory data`, data, err)
    }
  },

  getEBSOnDemandPrice: async () => {
    try {
      let url = APIConstants.ENDPOINT_INVENTORY_EBS_ON_DEMAND_PRICE
      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, err)
    }
  },

  getAllSavingCost: async (apiUrl, data) => {
    try {
      return await APIService.post(apiUrl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, err)
    }
  },

  //==================================================
  // Idle Events
  //==================================================
  saveScheduleIdle: async (apiurl, data) => {
    try {
      return await APIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while scheduling idle`, apiurl, data, err)
    }
  },

  getIdleEvents: async (selectedAccount, apiUrl) => {
    try {
      let url = `${apiUrl}`

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching idle events`, apiUrl, err)
    }
  },

  updateScheduleIdle: async (apiurl, data) => {
    try {
      return await APIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while updating idle instances`, apiurl, data, err)
    }
  },

  deleteIdleEvents: async (apiUrl, data) => {
    try {
      let url = `${apiUrl}`

      return await APIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while deleting idle instances`, apiUrl, data, err)
    }
  },

  // =====================================
  // Tag resources by tags (AWS)
  // =====================================
  getTagResourcesByTags: async (data) => {
    try {
      const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
      const parseToJson = JSON.parse(userDetails)
      if (parseToJson['userId']) {
        data['userId'] = parseToJson['userId']
      }

      return await APIService.post(APIConstants.ENDPOINT_INVENTORY_TAG_RESOURCES_BY_TAGS, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching tag resources by tags (AWS)`, data, err)
    }
  },


  // =====================================
  // Azure Inventory
  // =====================================
    getAzureFilterTagList: async (apiUrl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      return await APIService.post(apiUrl, data)
    } catch (err) {
      DebugService.error(`Azure Inventory Api Service: Error Caught while fetching azure tag list`, apiUrl, err)
    }
  },

  getAzureInventory: async (selectedAccount, endpoint, dataRequest, filterData) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const data = {
        userAccountId: selectedAccount,
        ...dataRequest
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }

        if (filterData['selectedFilter'] !== 'tags' && filterData['selectedFilter'] !== '' && filterData['filterValue'] !== '') {
          data['searchingFilter'] = filterData['selectedFilter']
          data['searchingValue'] = [filterData['filterValue']]
        }
        if (filterData['selectedFilter'] !== '' && filterData['selectedFilter'] === 'tags' && filterData['tagKey'] !== '' && filterData['tagValues']?.length > 0 ) {
          data['searchingFilter'] = filterData['selectedFilter']
          data['searchTagKey'] = filterData['tagKey']?.['Key']
          data['searchingValue'] = filterData['tagValues']
        }
      }

      return await AzureAPIService.post(endpoint, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching azure instances`, err)
    }
  },

  scheduleAzureEvents: async (apiurl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while scheduling azure event`, apiurl, data, err)
    }
  },

  getScheduledAzureEvents: async (selectedAccount, apiUrl, dbType) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      let url = `${apiUrl}`

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (dbType) {
        url += `&serviceType=${dbType}`
      }

      return await AzureAPIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching scheduled azure events`, apiUrl, err)
    }
  },

  deleteScheduledAzureEvents: async (apiUrl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      let url = `${apiUrl}`

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while deleting scheduled azure instances`, apiUrl, data, err)
    }
  },

  azureInstantAction: async (apiurl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }
      let url = `${apiurl}`

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while ${data['status']}ing inventory azure instance`, apiurl, data, err)
    }
  },

  saveAzureScheduleIdle: async (apiurl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while scheduling azure idle`, apiurl, data, err)
    }
  },

  getAzureAllSavingCost: async (apiUrl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(apiUrl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, err)
    }
  },

  getAzureIdleEvents: async (selectedAccount, apiUrl) => {
    try {
      let url = `${apiUrl}`

      if (selectedAccount) {
        url += `?userAccountId=${selectedAccount}`
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.get(url)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching azure idle events`, apiUrl, err)
    }
  },

  updateAzureScheduleIdle: async (apiurl, data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(apiurl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while updating azure idle instances`, apiurl, data, err)
    }
  },

  deleteAzureIdleEvents: async (apiUrl, data) => {
    try {
      let url = `${apiUrl}`

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while deleting azure idle instances`, apiUrl, data, err)
    }
  },

  getAzureActivityInventory: async (apiurl, data) => {
    let url = `${apiurl}`

    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(url, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching azure activity data`, apiurl, data, err)
    }
  },

  getAzureFilterTagList: async (apiUrl, data) => {
    try {

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }

        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(apiUrl, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching inventory`, apiUrl, err)
    }
  },

  // =====================================
  // Tag resources by tags (Azure)
  // =====================================
  getAzureTagResourcesByTags: async (data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))

        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)
        if (parseToJson['userId']) {
          data['userId'] = parseToJson['userId']
        }
      }

      return await AzureAPIService.post(APIConstants.ENDPOINT_INVENTORY_TAG_RESOURCES_BY_TAGS, data)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching tag resources by tags (Azure)`, data, err)
    }
  },

    getUntaggedAzureInventory: async (selectedAccount) => {
    try {
      const dataRequest = {}

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
          dataRequest['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
          dataRequest['userId'] = parseToJson['userId']
        }

        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await AzureAPIService.post(APIConstants.ENDPOINT_INVENTORY_TAG_UNTAGGED_INSTANCES, dataRequest)
    } catch (err) {
      DebugService.error(`Inventory Api Service: Error Caught while fetching untagged inventory`, err)
    }
  },
};

export default InventoryApiService;
